import React from "react";
import "./Login.css";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../firebase";

import logoGif from "../assets/cartesium-logo.png";

const Login = () => {
  const handleLogin = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Google Sign-in Error:", error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <h1 className="cartesium-title">Cartesium</h1>
        <p className="cartesium-tagline">
        Votre application intelligente de fiches de révision en <span>maths, physique et chimie </span>, avec de magnifiques formules.
        </p>
        <ul className="features">
          <li>📚 Organisez par matière et chapitre</li>
          <li>🧠 Mémorisez grâce à la répétition espacée</li>
          <li>📐 Parfait pour les élèves et les passionnés de sciences</li>
        </ul>
        <button className="login-btn" onClick={handleLogin}>Connectez-vous avec Google</button>
      </div>

      <div className="login-right">
        <img src={logoGif} alt="cartesium-logo" className="login-img" />
      </div>

      <div className="footer">
        <a
          href="https://www.instagram.com/elias.helfand"
          target="_blank"
          rel="noopener noreferrer"
        >
          @elias.helfand
        </a>
      </div>
    </div>
  );
};

export default Login;